var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { getMessageSanitizationChannel } from 'app/utils/htmlSanitizer';
import { getMessageMarkup } from 'app/utils/messages';
import { Message as MessageComp } from '../message';
const TextMessage = (_a) => {
    var { message, catchInternalLinks } = _a, otherProps = __rest(_a, ["message", "catchInternalLinks"]);
    const navigate = useNavigate();
    const sanitizationChannel = getMessageSanitizationChannel(message);
    const handleCatchInternalLinks = (e) => {
        if (e.target instanceof HTMLAnchorElement) {
            const origin = window.location.origin;
            const href = e.target.href;
            if (href.indexOf(origin) === 0) {
                e.preventDefault();
                const relativeUrl = href.replace(origin, '');
                navigate(relativeUrl);
            }
        }
    };
    const preparedMarkup = useMemo(() => {
        return getMessageMarkup(message);
    }, [message]);
    return (_jsx(MessageComp, Object.assign({}, otherProps, { onClick: catchInternalLinks ? handleCatchInternalLinks : undefined, markup: preparedMarkup, channel: sanitizationChannel })));
};
export default TextMessage;
